export function invariant(
  predicate: unknown,
  message: string
): asserts predicate {
  if (predicate) {
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    // only throw in non-production environments
    throw new Error(message);
  } else {
    console.error(message);
  }
}
